<template>
  <div ref="container" :class="wrapperClass">
    <div :class="iconClass" @click="toggleMenu($event)">
      <ellipsis-outline v-if="!icon" class="fill-current h-6 w-6"/>
      <component :is="icon" v-else class="w-6 h-4 mt-2 cursor-pointer fill-current text-inherit"></component>
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="menuOpen" v-on-click-outside="closeMenu"
        :class="[{ 'right-0': !rightSide, 'left-0': rightSide }, dropMenuClass || 'absolute top-0 mt-13 z-40']">
        <div :class="dropPanelClass">
          <div class="p-4 pb-1">
            <p v-if="helpText" :class="helpTextClass">
              {{ helpText }}
            </p>
            <div v-for="item in menuItems" :key="item.text" class="drop-menu-item mb-3 text-sm hover:text-primary hover:font-bold" :class="{
              'cursor-not-allowed opacity-50': item.disabled,
              'cursor-pointer': !item.disabled
            }" @click.stop="callMenuAction(item)">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { twJoin } from 'tailwind-merge';
import EllipsisOutline from '../assets/icons/ellipsis-h-alt.svg';
import directives from '../directives';

export default {
  name: 'DropMenu',
  directives,
  components: {EllipsisOutline},
  props: {
    menuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    icon: {
      type: [Object, null],
      default: null
    },
    small: {
      type: Boolean,
      default: false
    },
    smallIcon: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: null
    },
    dropMenuClass: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'base'
    }
  },
  data() {
    return { menuOpen: false, rightSide: false };
  },
  computed: {
    wrapperClass() {
      const baseClass = 'relative select-none';
      const sizeClass = this.smallIcon ? 'w-8 h-6' : 'w-13 h-13';
      return twJoin(baseClass, sizeClass);
    },
    iconClass() {
      const baseClass = 'flex items-center justify-center cursor-pointer';
      const sizeClass = this.smallIcon ? 'w-full h-5' : 'h-13';
      const variantClass = {
        base: 'text-grey-500',
        dark: 'text-secondary-invert'
      };
      return twJoin(baseClass, sizeClass, variantClass[this.variant]);
    },
    dropPanelClass() {
      const baseClass = 'rounded-lg border';
      const sizeClass = this.small ? 'w-40' : 'w-64';
      const variantClass = {
        base: 'bg-white text-grey-700 border-grey-200',
        dark: 'bg-secondary-dark text-secondary-invert border-secondary'
      };
      return twJoin(baseClass, sizeClass, variantClass[this.variant]);
    },
    helpTextClass() {
      const baseClass = 'mb-3 pb-3 italic border-b text-sm cursor';
      const variantClass = {
        base: 'text-grey-700 border-grey-700',
        dark: 'text-secondary-invert border-secondary-light'
      };
      return twJoin(baseClass, variantClass[this.variant]);
    }
  },
  methods: {
    toggleMenu() {
      if (this.$refs.container.getBoundingClientRect().left < 224)
        this.rightSide = true;
      else this.rightSide = false;
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    callMenuAction(menuItem) {
      if (!menuItem.disabled) {
        this.menuOpen = false;
        menuItem.callback();
        this.$emit('action-called');
      }
    }
  }
};
</script>
